import { FILE_URL, MEDIA_TYPE } from '../../../forms/ReusableFormFields/AdFileUpload/fields'
import { CAROUSEL_ITEMS, FORMAT_CAROUSEL, FORMAT_OPTION, FORMAT_SINGLE } from '../../../forms/Facebook/AdForms/fields'

import { getFacebookVideoPicture } from '../FacebookPreviews/FacebookSingleMediaAdPreview/FacebookSingleMediaAdThumbnail/FacebookVideoPreview/helpers'
import { instagramPositions } from '../../../forms/Facebook/constants'

export const isStoryPlacements = placementPositions => {
  // if lineItem placement_positions consist only of storyPlacements items, then use story preview
  // if placement_positions is blank or has at least one different placement
  // then preview type is not story, but single or carousel instead
  const storyPlacements = [
    ...instagramPositions,
    'facebook_story',
    'instagram_reels',
    'instagram_story',
    'messenger_story',
    'facebook_facebook_reels'
  ]

  return (
    placementPositions &&
    !!placementPositions.length &&
    placementPositions.every(item => storyPlacements.includes(item))
  )
}
export const calculateImageAspectRatio = imageUrl => {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = function () {
      const aspectRatio = this.width / this.height
      resolve(aspectRatio)
    }
    img.onerror = reject
    img.src = imageUrl
  })
}

export const getFirstMediaItem = formikValues => {
  // We need to get firstMediaItem when defining media ratio, we use it in few places:
  // - AdCardPreview to define ad preview height
  // - AdFacebookPreview to define if media is story ratio (9:16), in that case we may represent it as story
  let mediaItem = {}

  if (formikValues[FORMAT_OPTION] === FORMAT_SINGLE) {
    // todo refactor to use formikValues[SINGLE_MEDIA_ITEM]
    mediaItem = formikValues
  } else if (formikValues[FORMAT_OPTION] === FORMAT_CAROUSEL) {
    mediaItem = formikValues[CAROUSEL_ITEMS]?.[0]
  }

  return mediaItem
}

export const getMediaItemImageUrl = (mediaItem = {}, imageUrls) => {
  // We represent facebook video as image, this helper is used to get actual image url based on mediaType
  const fileUrl = mediaItem[FILE_URL]
  const mediaType = mediaItem[MEDIA_TYPE]

  return mediaType === 'video' ? getFacebookVideoPicture(mediaItem, imageUrls) : fileUrl
}
